import { Storage } from '../types'

export const localStorageAdapter = (): Storage => {
	return {
		getItem: (key: string) => {
			return new Promise(resolve => {
				resolve(localStorage.getItem(key))
			})
		},
		setItem: (key: string, value: string) => {
			return new Promise(resolve => {
				localStorage.setItem(key, value)
				resolve()
			})
		},
		removeItem: (key: string) => {
			return new Promise(resolve => {
				localStorage.removeItem(key)
				resolve()
			})
		},
		clearStorage: () => {
			return new Promise(resolve => {
				localStorage.clear()
				resolve()
			})
		}
	}
}
